<script lang="ts">
const __DsBlock = {
	icon: 'lucide:tag',
	description: 'A short text to represent a status or a category.',
	category: 'basic',
	options: ({ form, values }) => form([
		{
			name: 'label',
		},
		{
			name: 'color',
			type: 'enum',
			values: ['primary', 'success', 'info', 'warning', 'error', 'neutral', 'custom'],
		},
		{
			name: 'customColor',
			hidden: () => values.color !== 'custom',
			render: (props: any) => h(LazyDInputColor, { ...props, defaultValuePreset: true }),
		},
		{
			name: 'variant',
			type: 'enum',
			values: ['solid', 'outline', 'soft', 'subtle'],
		},
		{
			name: 'size',
			type: 'enum',
			values: ['xs', 'sm', 'md', 'lg'],
		},
		{
			name: 'icon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			name: 'rounded',
		},
	]),
}
</script>
<script lang="ts" setup>
import type { BadgeProps } from '#layers/ui';
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { computed, h } from 'vue';
import { LazyDInputColor } from '#components';
import { defineBlock } from '#layers/block-engine';

interface BadgeBlockProps extends Pick<BadgeProps, 'color' | 'variant' | 'size' | 'icon' | 'customColor'> {
	label?: string;
	rounded?: boolean;
}

const props = withDefaults(defineProps<BadgeBlockProps>(), {
	label: 'Badge',
	color: 'neutral',
	variant: 'soft',
	size: 'md',
});

;

const badgeProps = computed(() => {
	return {
		...props,
		customColor: props.color === 'custom' ? props.customColor : undefined,
	};
});
</script>

<template>
	<!-- Blocks should be block elements by default so I wrap the badge in a div -->
	<div class="flex justify-center">
		<DBadge v-bind="badgeProps" />
	</div>
</template>
